'use client';
/**
 * Предотвращает исходный `event`, возвращая св-во `defaultPrevented` в true.
 */ const secretlyPrevent = (event)=>{
    if (event) {
        event.preventDefault();
        event.defaultPrevented = false;
    }
};

export { secretlyPrevent };
//# sourceMappingURL=secretlyPrevent.js.map
